import React from 'react'
import ALListPage from './ALListPage'

const ALBreadcrumb = () => <>AL</>

const alRoutes = [
  {
    breadcrumb: ALBreadcrumb,
    path: '',
    element: <ALListPage />,
    children: [],
  },
]

export default alRoutes
